module.exports = __webpack_public_path__ + "static/media/background-phone.3fde40fa.svg";